// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { BooleanResponse } from '../common/common_responses_pb';
import { file_common_common_responses } from '../common/common_responses_pb';
import type { BffCallError_HasNoPermissionsForCall } from './call_errors_pb';
import { file_call_call_errors } from './call_errors_pb';

/**
 * Describes the file call/call_responses.proto.
 */
export const file_call_call_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChljYWxsL2NhbGxfcmVzcG9uc2VzLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCK3AQoSQ3JlYXRlQ2FsbFJlc3BvbnNlEjoKB3N1Y2Nlc3MYASABKAsyJy5jb20uZ2VtLmJmZi5jb250cmFjdC5DcmVhdGVDYWxsU3VjY2Vzc0gAEl0KF2hhc05vUGVybWlzc2lvbnNGb3JDYWxsGAIgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuQmZmQ2FsbEVycm9yLkhhc05vUGVybWlzc2lvbnNGb3JDYWxsSABCBgoEdHlwZSImChFDcmVhdGVDYWxsU3VjY2VzcxIRCgljaGFubmVsSWQYASABKAkiVwoTRGVjbGluZUNhbGxSZXNwb25zZRI4CgdzdWNjZXNzGAEgASgLMiUuY29tLmdlbS5iZmYuY29udHJhY3QuQm9vbGVhblJlc3BvbnNlSABCBgoEdHlwZSLDAQoYQ3JlYXRlQ29uZmVyZW5jZVJlc3BvbnNlEkAKB3N1Y2Nlc3MYASABKAsyLS5jb20uZ2VtLmJmZi5jb250cmFjdC5DcmVhdGVDb25mZXJlbmNlU3VjY2Vzc0gAEl0KF2hhc05vUGVybWlzc2lvbnNGb3JDYWxsGAIgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuQmZmQ2FsbEVycm9yLkhhc05vUGVybWlzc2lvbnNGb3JDYWxsSABCBgoEdHlwZSIsChdDcmVhdGVDb25mZXJlbmNlU3VjY2VzcxIRCgljaGFubmVsSWQYASABKAkiWAoSQ3JlYXRlUm9vbVJlc3BvbnNlEjoKB3N1Y2Nlc3MYASABKAsyJy5jb20uZ2VtLmJmZi5jb250cmFjdC5DcmVhdGVSb29tU3VjY2Vzc0gAQgYKBHR5cGUiNAoRQ3JlYXRlUm9vbVN1Y2Nlc3MSDAoEbGluaxgBIAEoCRIRCgljaGFubmVsSWQYAiABKAlCGAoUY29tLmdlbS5iZmYuY29udHJhY3RQAWIGcHJvdG8z',
    [file_common_common_responses, file_call_call_errors]
  );

/**
 * @generated from message com.gem.bff.contract.CreateCallResponse
 */
export type CreateCallResponse = Message<'com.gem.bff.contract.CreateCallResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CreateCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateCallSuccess success = 1;
         */
        value: CreateCallSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.BffCallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: BffCallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CreateCallResponse.
 * Use `create(CreateCallResponseSchema)` to create a new message.
 */
export const CreateCallResponseSchema: GenMessage<CreateCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 0);

/**
 * @generated from message com.gem.bff.contract.CreateCallSuccess
 */
export type CreateCallSuccess = Message<'com.gem.bff.contract.CreateCallSuccess'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.bff.contract.CreateCallSuccess.
 * Use `create(CreateCallSuccessSchema)` to create a new message.
 */
export const CreateCallSuccessSchema: GenMessage<CreateCallSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 1);

/**
 * @generated from message com.gem.bff.contract.DeclineCallResponse
 */
export type DeclineCallResponse = Message<'com.gem.bff.contract.DeclineCallResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.DeclineCallResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.BooleanResponse success = 1;
         */
        value: BooleanResponse;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.DeclineCallResponse.
 * Use `create(DeclineCallResponseSchema)` to create a new message.
 */
export const DeclineCallResponseSchema: GenMessage<DeclineCallResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 2);

/**
 * @generated from message com.gem.bff.contract.CreateConferenceResponse
 */
export type CreateConferenceResponse = Message<'com.gem.bff.contract.CreateConferenceResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CreateConferenceResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateConferenceSuccess success = 1;
         */
        value: CreateConferenceSuccess;
        case: 'success';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.BffCallError.HasNoPermissionsForCall hasNoPermissionsForCall = 2;
         */
        value: BffCallError_HasNoPermissionsForCall;
        case: 'hasNoPermissionsForCall';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CreateConferenceResponse.
 * Use `create(CreateConferenceResponseSchema)` to create a new message.
 */
export const CreateConferenceResponseSchema: GenMessage<CreateConferenceResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 3);

/**
 * @generated from message com.gem.bff.contract.CreateConferenceSuccess
 */
export type CreateConferenceSuccess = Message<'com.gem.bff.contract.CreateConferenceSuccess'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.bff.contract.CreateConferenceSuccess.
 * Use `create(CreateConferenceSuccessSchema)` to create a new message.
 */
export const CreateConferenceSuccessSchema: GenMessage<CreateConferenceSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 4);

/**
 * @generated from message com.gem.bff.contract.CreateRoomResponse
 */
export type CreateRoomResponse = Message<'com.gem.bff.contract.CreateRoomResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.CreateRoomResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CreateRoomSuccess success = 1;
         */
        value: CreateRoomSuccess;
        case: 'success';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.CreateRoomResponse.
 * Use `create(CreateRoomResponseSchema)` to create a new message.
 */
export const CreateRoomResponseSchema: GenMessage<CreateRoomResponse> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 5);

/**
 * @generated from message com.gem.bff.contract.CreateRoomSuccess
 */
export type CreateRoomSuccess = Message<'com.gem.bff.contract.CreateRoomSuccess'> & {
  /**
   * @generated from field: string link = 1;
   */
  link: string;

  /**
   * @generated from field: string channelId = 2;
   */
  channelId: string;
};

/**
 * Describes the message com.gem.bff.contract.CreateRoomSuccess.
 * Use `create(CreateRoomSuccessSchema)` to create a new message.
 */
export const CreateRoomSuccessSchema: GenMessage<CreateRoomSuccess> =
  /*@__PURE__*/
  messageDesc(file_call_call_responses, 6);
